<template>
  <div class="box-wrap">
    <div class="box">
      <p class="auth-brand"><BrandLogo large /></p>
      <h1>{{ $t('Forgot your password?') }}</h1>
      <p v-if="!sent" class="lead">{{ $t('Enter your e-mail address and we will send you a link to choose a new one.') }}</p>

      <form v-if="!sent" @submit.prevent="submit">
        <label for="forgot-email">{{ $t('Email') }}</label>
        <input id="forgot-email" v-model="email" type="email" placeholder="your@email.com" required>
        <button type="submit" :disabled="busy">{{ busy ? $t('Sending...') : $t('Send the link') }}</button>
      </form>
      <p v-else class="done">{{ message }}</p>

      <p v-if="error" class="error-message">{{ error }}</p>
      <router-link to="/login" class="back">{{ $t('Back to login') }}</router-link>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '../api'
import BrandLogo from '../components/BrandLogo.vue'
import { t } from '../i18n'

const email = ref('')
const busy = ref(false)
const sent = ref(false)
const message = ref('')
const error = ref('')

const submit = async () => {
  busy.value = true
  error.value = ''
  try {
    const response = await api.post('/api/auth/forgot-password', { email: email.value })
    message.value = t(response.data.message)
    sent.value = true
  } catch (err) {
    const detail = err.response?.data?.detail
    error.value = t((Array.isArray(detail) ? detail.map((d) => d.msg).join('; ') : detail) || 'Could not reach the server.')
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.auth-brand {
  display: flex;
  justify-content: center;
  margin: 0 0 22px;
}

.box-wrap {
  display: flex;
  justify-content: center;
  padding: 60px 20px;
}

.box {
  width: 100%;
  max-width: 400px;
  padding: 28px;
  border-radius: 10px;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

.dark .box {
  background: #2a2a2a;
}

h1 {
  margin: 0 0 8px 0;
  font-size: 22px;
}

.lead {
  margin: 0 0 16px 0;
  color: #666;
  font-size: 14px;
}

label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
}

input {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 14px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font: inherit;
}

button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 6px;
  background: #4CAF50;
  color: white;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

button:disabled {
  opacity: 0.6;
  cursor: default;
}

.done {
  padding: 12px;
  border-radius: 6px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 14px;
}

.error-message {
  padding: 10px;
  border-radius: 4px;
  background: #ffebee;
  color: #c62828;
  font-size: 14px;
}

.back {
  display: block;
  margin-top: 16px;
  font-size: 14px;
  text-align: center;
}
</style>
